(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push();
  angular.module('MktzapApp.Controllers')
    .controller('TeamManagementController', team)
  team.$inject = ['$rootScope', 'DashboardService', 'NotificationService', '$state'];
  function team ($rootScope, DashboardService, NotificationService, $state) {
    var vmTeamCtrl = this;
    var columnChart = {};
    var pieChart = {};
    vmTeamCtrl.type = '1';

    $rootScope.fullscreen = true;

    var options = function () {
      return {
        backgroundColor: 'none',
        colors: ['#05e41a', '#00ace4', '#e754ec', '#ffb30f'],
        vAxis: {
          titleTextStyle: { color: '#fff' },
          textStyle: { color: 'white' }
        },
        hAxis: {
          minValue: 0,
          titleTextStyle: { color: '#000' },
          textStyle: { color: 'white' }
        },
        legend: {
          textStyle: {
            color: 'white'
          },
          position: 'top'
        }
      };
    }

    var pieChartOptions = function () {
      return {
        backgroundColor: 'none',
        colors: ['#05e41a', '#00ace4', '#e754ec', '#ffb30f'],
        vAxis: {
          titleTextStyle: { color: '#fff' },
          textStyle: { color: 'white' }
        },
        hAxis: {
          minValue: 0,
          titleTextStyle: { color: '#000' },
          textStyle: { color: 'white' }
        },
        legend: {
          textStyle: {
            color: 'white'
          },
          position: 'top'
        },
        is3D: true
      };
    }

    columnChart.type = 'ComboChart';
    columnChart.options = options();
    columnChart.options.seriesType = 'bars';
    columnChart.options.series = { 2: { type: 'line' } };
    vmTeamCtrl.columnChartObject = columnChart;

    pieChart.type = 'PieChart';
    pieChart.options = pieChartOptions();
    vmTeamCtrl.pieChartObject = pieChart;

    vmTeamCtrl.dates = {
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month')
    };

    vmTeamCtrl.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    // Dashboard rotation
    if ($state.params.time) {
      var dash;
      if ($state.params.op) {
        dash = 'main.dashboard-operational-summary';
      } else if ($state.params.business) {
        dash = 'main.dashboard-business-management';
      }

      if ($state.params.from && $state.params.to) {
        vmTeamCtrl.filters.fromDate = $state.params.from;
        vmTeamCtrl.filters.toDate = $state.params.to;
      }

      setTimeout(function () {
        $state.go(dash, {
          time: $state.params.time,
          business: $state.params.business,
          team: $state.params.team,
          op: $state.params.op,
          from: vmTeamCtrl.filters.fromDate,
          to: vmTeamCtrl.filters.toDate
        });
        clearInterval(filterInterval);
        clearInterval(carouselInterval);
      }, $state.params.time);
    }

    vmTeamCtrl.dateSelected = function (type, date) {
      if (type == 'from') {
        vmTeamCtrl.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vmTeamCtrl.pkadayFromDate.setMaxDate(date);
      }
    };

    vmTeamCtrl.calcMeta = function () {
      var meta_qtd; var check_class; var faltam = 0;
      vmTeamCtrl.calc_meta = 0;
      vmTeamCtrl.faltam = 0;

      if (vmTeamCtrl.counters && vmTeamCtrl.meta > 0) {
        if (parseInt(vmTeamCtrl.type) == 1) {
          meta_qtd = Math.round((vmTeamCtrl.counters.finalizados * vmTeamCtrl.meta) / 100);
          vmTeamCtrl.calc_meta = meta_qtd;
        } else {
          if (vmTeamCtrl.counters.finalizados > 0) {
            meta_qtd = vmTeamCtrl.meta;
            vmTeamCtrl.calc_meta = parseFloat((vmTeamCtrl.meta / vmTeamCtrl.counters.finalizados) * 100, 2).toFixed(2) + '%';
          }
        }
        if (vmTeamCtrl.counters.sucesso) {
          faltam = meta_qtd - parseFloat(vmTeamCtrl.counters.sucesso);
          if (vmTeamCtrl.counters.sucesso < meta_qtd) {
            vmTeamCtrl.counters.perc_sucessos = parseFloat((vmTeamCtrl.counters.sucesso / meta_qtd) * 100, 2).toFixed(2);
          } else {
            vmTeamCtrl.counters.perc_sucessos = 100;
          }
          if (faltam < 0) {
            faltam = 0;
          }
          vmTeamCtrl.faltam = faltam;
        }
        if (vmTeamCtrl.counters.perc_sucessos >= 100) {
          vmTeamCtrl.counters.class_meta = 'sucesso';
          vmTeamCtrl.counters.ico_meta = 'up';
        } else if (vmTeamCtrl.counters.perc_sucessos >= 50) {
          vmTeamCtrl.counters.class_meta = 'secundaria';
          vmTeamCtrl.counters.ico_meta = 'right';
        } else {
          vmTeamCtrl.counters.class_meta = 'erro';
          vmTeamCtrl.counters.ico_meta = 'down';
        }
      } else {
        vmTeamCtrl.meta = 0;
        vmTeamCtrl.faltam = 0;
        vmTeamCtrl.counters.class_meta = 'secundaria';
        vmTeamCtrl.counters.ico_meta = 'right';
      }
    };

    DashboardService.loadFiltersBM()
      .$promise
      .then(function (data) {
        vmTeamCtrl.sectors = data.sectors;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorGetFilters);
      });

    vmTeamCtrl.filterDatas = function () {
      DashboardService.filterTeamManagement({
        filters: vmTeamCtrl.filters
      })
        .$promise
        .then(function (data) {
          var pieData = { cols: [
            { id: 't', label: $rootScope.labels.status, type: 'string' },
            { id: 's', label: $rootScope.labels.atts, type: 'number' }
          ],
          rows: [] };
          var columnData = { cols: [
            { id: 't', label: $rootScope.labels.status, type: 'string' },
            { id: 's', label: $rootScope.labels.atts, type: 'number' },
            { id: 's', label: $rootScope.labels.finalized, type: 'number' },
            { id: 's', label: $rootScope.labels.success, type: 'number' }
          ],
          rows: [] };

          vmTeamCtrl.counters = data.counters;
          vmTeamCtrl.users = data.users;
          vmTeamCtrl.users_name = data.users_name;
          vmTeamCtrl.counters_messages = data.counters_messages;

          angular.forEach(data.statuschart, function (row, key) {
            pieData.rows.push({ c: [{ v: row.name.trim() }, { v: parseInt(row.atendimentos) }] });
          });

          angular.forEach(data.chartusers, function (row, key) {
            columnData.rows.push({ c: [
              { v: row.name.trim() },
              { v: parseInt(row.atendimentos) },
              { v: parseInt(row.finalizados) },
              { v: parseInt(row.sucesso) }
            ] });
          });
          columnChart.data = columnData;
          pieChart.data = pieData;
          vmTeamCtrl.calcMeta();
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorGetInfo);
        });
    }

    vmTeamCtrl.autocomplete = function (term) {
      var filter = [];
      var rgex = new RegExp(term.toLowerCase());
      vmTeamCtrl.sectors.map(function (person) {
        if (person.name.toLowerCase().match(rgex)) {
          filter.push(person);
        }
      });
      return filter;
    }

    vmTeamCtrl.filterByDay = function () {
      vmTeamCtrl.filters = {
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY')
      };
      vmTeamCtrl.filterDatas();

      var viewByDay = document.getElementById('viewByDay');
      viewByDay.setAttribute('class', 'active');
      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.classList.remove('class', 'active');
    }

    vmTeamCtrl.filterByMonth = function () {
      vmTeamCtrl.filters = {
        fromDate: moment().startOf('month').format('DD/MM/YYYY'),
        toDate: moment().endOf('month').format('DD/MM/YYYY')
      };
      vmTeamCtrl.filterDatas();

      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.setAttribute('class', 'active');
      var viewByDay = document.getElementById('viewByDay');
      viewByDay.classList.remove('class', 'active');
    }

    vmTeamCtrl.toggleFilters = function () {
      var div = document.getElementById('filters_info');
      if (div.style.display === 'none') {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    }

    vmTeamCtrl.carousel = function () {
      var slide0 = document.getElementById('slide_0');
      var slide1 = document.getElementById('slide_1');
      if (!slide0.classList.contains('active')) {
        slide0.click();
      } else {
        slide1.click();
      }
    }

    var filterInterval = setInterval(function () {
      vmTeamCtrl.filterDatas();
    }, 60000);

    var carouselInterval = setInterval(function () {
      vmTeamCtrl.carousel();
    }, 5000);
  }
})();
